const fromdataedit = [
  {
    inputdata: '',
    title: '父级菜单',
    fontSize: '14px',
    color: '#333333',
    placeholder: '请选择',
    types: '',
    inputtype: 'cascaderNode',
    width: '490px',
    options: [],
  },
  {
    inputdata: "",
    title: "菜单编码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "480px",
  },
  {
    inputdata: "",
    title: "菜单名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "480px",
  },
  {
    inputdata: "",
    title: "菜单链接",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "480px",
  },
  {
    inputdata: "",
    title: "优先级",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "numberAL",
    width: "490px",
    min: 1,
    max: 5000,
  },
  {
    inputdata: "",
    title: "是否显示",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "checkboxs",
    checkboxdata: [
      {
        label: "1",
        value: "",
      },
    ],
    width: "",
    lablewith: "85px",
  },
  {
    inputdata: "",
    title: "是否经销商前台菜单",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "checkboxs",
    checkboxdata: [
      {
        label: "1",
        value: "",
      },
    ],
    width: "",
    lablewith: "320px",
  },
];
export default fromdataedit;
